var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import PopupTitle from '@ntuctech/devex-tangram/PopupTitle';
import { withForwardedRef } from '../utils/helpers/reactHelpers';
const ModalTitle = (props) => {
    const { children, forwardedRef, className: classNameProp } = props, others = __rest(props, ["children", "forwardedRef", "className"]);
    return children ? (React.createElement(PopupTitle, Object.assign({ responsive: true, ref: forwardedRef, className: clsx(classNameProp, '_ndsModalTitle') }, others), children)) : null;
};
ModalTitle.propTypes = {
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    forwardedRef: PropTypes.any,
    className: PropTypes.string
};
ModalTitle.defaultProps = {
    children: null,
    forwardedRef: React.createRef(),
    className: null
};
export default withForwardedRef(ModalTitle);
//# sourceMappingURL=ModalTitle.js.map